import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import Chip from '@mui/material/Chip';

import { newStopSaleCreation } from "./stopsaleAction";
import { getAllProduct } from "../product/productAction";

import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { DefaultEditor } from 'react-simple-wysiwyg';
import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2'
import 'react-phone-number-input/style.css'
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { FaEdit, FaTrash, FaPlus, FaEye, FaArrowLeft } from 'react-icons/fa';
import { getAllMainSubProduct } from "../subproduct/subproductAction";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';



const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CreateProduct = () => {
  const dispatch = useDispatch();
  const ProductRef = useRef(null);
  const navigate = useNavigate();
  const [subproductdisplay, setSubproductdisplay] = useState([]);
  const [sdate, setSdate] = useState('');
  const [edate, setEdate] = useState('');
  const [remarks, setRemarks] = useState('');
  const [subdata, setSubdata] = useState([]);
  const [productid , setProductid ] = useState('');

  
  const handleStartDateChange = (e) => {
    setSdate(e.target.value);
    setEdate('');
  };

  const handleChangeRSub = (event, options) => {
    if (options && options.length > 0) {
      const selectedIds = options.map((option) => option.id); // Get an array of selected ids
      setSubdata(selectedIds);
    } else {
      setSubdata([]); // If no options are selected, reset the subdata state to an empty array
    }
  };
  
  

  

  
console.log("check data",subdata)
  const removeRSub = (id) => {
    setSubdata([...subdata.filter((subproductid) =>
      subproductid == id)])
  }


  const { register, reset, handleSubmit, formState: { errors } } = useForm();

  const { products } = useSelector((state) => state.productList);

  const { subproducts2, pisLoading, pdstatus, pdmessage } = useSelector((state) => state.subproductList);

  const [selectedSubProducts, setSelectedSubProducts] = useState([]);



  const handleProductChange = (e) => {
    setProductid(e);


    const finalSub = subproducts2.filter(obj => obj.product_id == e);
    setSubproductdisplay(finalSub);
    console.log("watch",finalSub);


  }

  useEffect(() => {
    dispatch(getAllProduct());
    dispatch(getAllMainSubProduct());
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

      const newStopSaleCreation1 = {
      sdate,
      edate,
      productid,
      subdata,
      remarks
      }

      dispatch(
        newStopSaleCreation(newStopSaleCreation1)
      )



        navigate('/stopsaleList');


   

  }

  
  const canSave = Boolean(sdate) && Boolean(edate) && Boolean(subdata.length !== 0) && Boolean(productid)
 
  console.log("check console data" , subdata)
 

  const selectedOptions = subproductdisplay.filter((option) =>
  subdata.includes(option.id)
);

  return (
    <>

      <Container className="my-4 mx-4 container-xl ">

      <Card  style={{marginLeft:'100px',marginTop:'-60px'}}>

          <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Create Stop Sale</h4></Card.Header>
          <Card.Body>
            <Row>
              <Col>

                <Link to="/stopsaleList"><span className="badge bg-success" style={{ backgroundColor: 'rgb(156 186 237)', color: 'white' }}><FaArrowLeft />&nbsp;Go Back</span></Link>

                <br />
              
              </Col>
            </Row>
            <br />


            <Form className=" mx-4 my-2" component="form" noValidate autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit(e))}> {/* handleOnSubmit() */}



              <Row className="mb-3">

                <Form.Group as={Col} controlId="formGridMobile">
                  <Form.Label>Start Date<span className='text-danger'>*</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="sdate"
                    min={new Date().toISOString().split('T')[0]}
                    required
                    autoComplete='off'
                    placeholder="Enter the start date"
                    value={sdate}
                    onChange={handleStartDateChange}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridMobile">
                  <Form.Label>End Date<span className='text-danger'>*</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="edate"
                    min={sdate}
                    required
                    disabled={sdate ? 0 : 1}
                    autoComplete='off'
                    placeholder="Enter the end date"
                    value={edate}
                    onChange={(e) => setEdate(e.target.value)}
                  />
                </Form.Group>


              </Row>

              <Row className="mb-3">



                <Form.Group as={Col} controlId="formGridServiceType">
                  <Form.Label>Product Name <span className='text-danger'>*</span></Form.Label>
                  <Form.Select name="productid" style={{ height: '57px' }} required="true" onChange={(e) => handleProductChange(e.target.value)}>
                    <option value="" >Choose</option>
                    {products.map((products, index) =>

                      <option key={products.id} value={products.id} >{products.product_name}</option>
                    )}
                  </Form.Select>
                </Form.Group>
                <Form.Group as={Col} controlId="formGridReservationEmail">
      <Form.Label>Sub Product Name<span className='text-danger'>*</span></Form.Label>

      <Autocomplete
        multiple
        id="checkboxes-tags-demo"
        options={subproductdisplay}
        disableCloseOnSelect
        limitTags={1}
        style={{ height: "38px" }}
        getOptionLabel={(option) => option.subproduct_name}
        value={subproductdisplay.filter((option) => subdata.includes(option.id))}
        onChange={handleChangeRSub}
        renderOption={(props, option) => {
          const isSelected = subdata.includes(option.id);

          return (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8, height: "38px" }}
                checked={isSelected}
              />
              {option.subproduct_name}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            style={{ height: "38px", fontSize: "15px" }}
            // label="Sub Product Name"
            placeholder="Select Sub Product"
          />
        )}
      />
    </Form.Group>

              </Row>
              <Form.Group as={Col} controlId="formGridProductdescription">
                <Form.Label>Remarks:</Form.Label>

                <DefaultEditor rows="5" name="remarks" style={{ backgroundColor: 'white' }} value={remarks}  onChange={(e) => setRemarks(e.target.value)}
 
                />

              </Form.Group>
              <br />
              <div class="d-grid  col-2 mx-auto" style={{ display: "flex" }}>
                <Button variant="primary" type="submit" className="btn btn-success btn-block" style={{ backgroundColor: '#1c355e' }} disabled={!canSave}>
                  <FontAwesomeIcon icon={faRightToBracket} /> Save
                </Button>
              </div>

            </Form>





          </Card.Body>
        </Card>

      </Container>
    </>
  );
}

export default CreateProduct;